// comments in lowercase
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Modal, Spin } from "antd";
import { ThemeProvider } from 'dlweb-components';
import styled from "styled-components";
import { useDialogs } from "../../hooks/useDialogs"; // adjust path

// tiny helper to submit a transient form into a named iframe
function postToNamedFrame({ action, target, fields }) {

  const form = document.createElement("form");
  form.method = "POST";
  form.action = action;
  form.target = target;
  form.style.display = "none";
  const data = fields || {};
  Object.keys(data).forEach((name) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = data[name] == null ? "" : String(data[name]);
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
  setTimeout(() => form.remove(), 0);
}

export default function LegacyDialog({
  open,
  title = "legacy dialog",
  width,
  height,
  frameName = "LegacyDialog",
  url,
  post,
  blankSrc = "about:blank",
  onCancel,
  afterClose,
  id
}) {

  const { openUpdateProfileDialog, openCheckInDialog } = useDialogs();
  
  const [ready, setReady] = useState(false);
  const initialSrc = useMemo(() => (post && !url ? blankSrc : (url || blankSrc)), [post, url, blankSrc]);

  useEffect(() => { setReady(false); }, [initialSrc, open]);

  useEffect(() => {
    if (!open || !post) return;
    const id = requestAnimationFrame(() => {
      postToNamedFrame({ action: post.action, target: frameName, fields: post.fields || {} });
    });
    return () => cancelAnimationFrame(id);
  }, [open, post, frameName]);

  useEffect(() => {
    function onMessage(e) {
      // validate shape
      if (!e || !e.data || typeof e.data !== "object") return;
      // optionally: check e.origin against your legacy site origin
      // if (e.origin !== window.location.origin) return;

      if (e.data.type === "LEGACY_MODAL_CLOSE") {
        // if a dlg id is provided, ensure it matches this modal
        // if (!e.data.dlg || e.data.dlg === id) {
          onCancel?.();
        // }
      }

      if(e.data.type === "OPEN_PARENT_MODAL") {
        const selectedTask = e.data.task;
        switch(e.data.dialog) {
          case 'UPDATE_PROFILE':
            openUpdateProfileDialog([e.data.selectedItems]);
            break;
          case 'CHECK_IN':
            openCheckInDialog(e.data.selectedItems);
            break;
          default:
            console.warn("Unknown modalType requested from legacy iframe:", e.data.modalType);
        }
      }
    }
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [id, onCancel]);

  return (
    <ThemeProvider
      globalToken={{ padding: 0 }}
    >
    <NoPaddingModal
      open={open}
      title={title}
      onCancel={onCancel}
      footer={null}
      width={width}
      styles={{body: {height: height, width: width, padding: 0}}}
      destroyOnClose
      maskClosable={false}
      afterClose={afterClose}
      // bodyStyle={{ padding: 0, height }}
    >
      {!ready &&
        <img alt="Loading..." style={{ position: 'absolute', top: "60px", left: "50%", transform: "translateX(-50%)" }} src="/legacy/images/processing.gif" />
        // <Spin size="medium" style={{ margin: '25px auto' }} />
      }
      <iframe
        name={frameName}
        title={title}
        src={initialSrc}
        style={{ display: ready ? "block" : "none", width: "100%", height: "100%", border: 0 }}
        onLoad={() => setReady(true)}
        // sandbox="allow-forms allow-scripts allow-downloads allow-popups allow-same-origin"
        referrerPolicy="no-referrer"
      />
    </NoPaddingModal>
    </ThemeProvider>
  );
}

const NoPaddingModal = styled(Modal)`
  .ant-modal-title {
    padding-left: 24px;
  }
  .ant-modal-content {
    overflow: hidden;
    padding: 15px 0 0 0;
  }
`;
